import { z } from 'zod'
import { correlationIdFromCloseableWebhookPayload } from '@nwwp/closeable'

// Salesforce LongTextArea fields (Lead/Opportunity Closeable_Handoff_Notes__c) cap at 131072 chars.
const SALESFORCE_LONG_TEXT_AREA_MAX_LENGTH = 131072

/**
 * Inbound Closeable handoff webhook body. Closeable echoes outbound Contact fields;
 * at least one of external_client_id / primary_phone / primary_email must be set.
 */
export const closeableEventSchema = z
  .strictObject({
    external_client_id: z.string().min(1).optional(),
    primary_phone: z.string().min(1).optional(),
    primary_email: z.string().min(1).optional(),
    handoff_notes: z.string().max(SALESFORCE_LONG_TEXT_AREA_MAX_LENGTH),
  })
  .superRefine((event, ctx) => {
    if (correlationIdFromCloseableWebhookPayload(event) === null) {
      ctx.addIssue({
        code: 'custom',
        message:
          'Closeable webhook requires a resolvable identity (external_client_id, US-normalized primary_phone, or primary_email)',
      })
    }
  })

export type CreateCloseableEvent = z.infer<typeof closeableEventSchema>
export type CloseableEvent = z.infer<typeof closeableEventSchema>
